import { render } from "./Customer.vue?vue&type=template&id=dd33392a&scoped=true"
import script from "./Customer.vue?vue&type=script&lang=js"
export * from "./Customer.vue?vue&type=script&lang=js"

import "./Customer.vue?vue&type=style&index=0&id=dd33392a&lang=css"
import "@/assets/styles/beneficiary.css?vue&type=style&index=1&id=dd33392a&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd33392a"]])

export default __exports__